import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSurveyTheme } from '../../hooks/useSurveyTheme'
import {
  Environments,
  getCurrentEnvironment,
} from '@csat/common/constants/environments'

const Head: React.FC = () => {
  const surveyTheme = useSurveyTheme()
  const environment = getCurrentEnvironment()

  const domainDataScript =
    surveyTheme.oneTrustDataDomainScript +
    (environment !== Environments.prod ? '-test' : '')

  // Due to changes in how react-helmet-async/React interact, OneTrust script needs to be manually added.
  // TLDR: otSDKStub requires the element be present on the page when the script executes,
  // react-helmet-async batches element injection, so isn't immediately present, so the script errors.
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"]'
    )
    if (existingScript) return

    const script = document.createElement('script')
    script.src = 'https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js'
    script.setAttribute('data-domain-script', domainDataScript)
    document.head.appendChild(script)
  }, [domainDataScript])

  return (
    <Helmet title={surveyTheme.pageTitle}>
      <link rel="shortcut icon" href={surveyTheme.favicon} />
    </Helmet>
  )
}

export default Head
